import { useGetUserSubscription } from '@forwardflow/hooks/customHooks'
import { useGetMonthlyBudgets } from '@forwardflow/hooks/customHooks/useGetMonthlyBudgets'
import { Skeleton } from 'antd'
import dayjs from 'dayjs'

export const NextBillingCycle = () => {
   const { data, isLoading } = useGetUserSubscription()
   const { data: budgetData } = useGetMonthlyBudgets()

   const billingDate = data?.nextBillingCycle?.currentPeriodEnd
      ? dayjs(data.nextBillingCycle.currentPeriodEnd).format('MMM D, YYYY')
      : ''

   const seatCount = data?.organizationSubscription?.seatCounts || 1
   const seatsCost = 97 + (seatCount - 1) * 50
   const phoneNumbersCost = data?.phoneNumbers?.price || 0
   const phoneCount = data?.phoneNumbers?.count || 0
   const rechargeAmount = (budgetData?.newLeadBudget || 0) + (budgetData?.reactivateLeadBudget || 0)
   const total = seatsCost + phoneNumbersCost + rechargeAmount

   return (
      <div className="flex-1">
         <p className="font-medium mb-5">Next Billing Cycle</p>
         {!isLoading ? (
            <div className="bg-[#474747]/10 rounded-xl border border-white/10 overflow-hidden">
               <div className="px-6 py-5 bg-white/[0.02]">
                  <p className="text-white/40 text-xs">Billing date</p>
                  <p className="text-white font-semibold text-xl mt-1">{billingDate}</p>
               </div>
               <div className="border-t border-white/10" />
               <div className="px-6 py-4 space-y-3">
                  <div className="flex items-center justify-between text-sm">
                     <span className="text-white/60">Subscription ({seatCount} user{seatCount !== 1 ? 's' : ''})</span>
                     <span className="text-white font-medium">${seatsCost.toFixed(2)}</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                     <span className="text-white/60">Phone numbers ({phoneCount})</span>
                     <span className="text-white font-medium">${phoneNumbersCost.toFixed(2)}</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                     <span className="text-white/60">Credit recharge</span>
                     <span className="text-white font-medium">${rechargeAmount.toFixed(2)}</span>
                  </div>
               </div>
               <div className="border-t border-white/10" />
               <div className="flex items-center justify-between px-6 py-4">
                  <span className="text-white font-semibold">Total</span>
                  <span className="text-primary font-semibold text-lg">${total.toFixed(2)}</span>
               </div>
            </div>
         ) : (
            <div>
               <Skeleton active className="my-6" />
               <Skeleton active />
            </div>
         )}
      </div>
   )
}
